import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200" data-id="element-239">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 px-4 flex justify-between items-center text-left hover:bg-gray-50 transition-colors" data-id="element-240">
        <span className="font-semibold text-lg text-gray-900 pr-4" data-id="element-241">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-242">
          <ChevronDownIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-243" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-244">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-245">
            <div className="px-4 pb-6 text-gray-700 leading-relaxed" data-id="element-246">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}